// Module
var code = "<div class=\"inline-chip-count-flex\" uib-tooltip-html=\"$ctrl.getTooltipHTML()\" tooltip-enable=\"$ctrl.overflowCount\"> <div class=\"chip-container\"></div> <div class=\"chip-count\" data-local-qa-id=\"overflow\" ng-if=\"$ctrl.overflowCount\"> ({{ $ctrl.overflowCount }}) </div> </div> ";
// Exports
export default code;